/* eslint-disable react-hooks/exhaustive-deps */
import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useState } from "react";
import { fetchFurtherInvestigationById } from "services/prosecutorPoliceService";
import { FurtherInvestigation } from "types";
import { errorHandler } from "utils/helper";
import FurtherInvestigationInformationTab from "./fragment/FurtherInvestigationInformationTab";
import { useParams } from "react-router-dom";

const FurtherInvestigationDetailForPolice = () => {
  const { furtherInvestigationId } = useParams();
  const { showTooltip } = useTooltip();
  const [file, setFile] = React.useState<FurtherInvestigation>();
  const [loading, setLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);

  const fetchData = (id: any) => {
    setLoading(true);
    fetchFurtherInvestigationById(id)
      .then((data) => {
        setFile(data);
        setLoading(false);
      })
      .catch((error) => {
        showTooltip(errorHandler(error));
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData(furtherInvestigationId);
  }, [refetch]);

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
            <span className="text-2xl">🔍</span>
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Further Investigation Details
            </h1>
            <p className="text-gray-600 mt-1">
              Review and manage further investigation requests and information.
            </p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <span className="ml-3 text-gray-600">
            Loading investigation details...
          </span>
        </div>
      ) : file ? (
        <FurtherInvestigationInformationTab
          file={file}
          setRefetch={setRefetch}
        />
      ) : (
        <div className="text-center py-12 text-gray-500 bg-gray-50 rounded-lg">
          No investigation data found
        </div>
      )}
    </div>
  );
};

export default FurtherInvestigationDetailForPolice;
